@if(isLoading()){
<app-loader message="Chargement des données..." class="margin"></app-loader>
}
@else {
<div class="container">

  <!-- Champs de recherche -->
  <mat-form-field style="width: 100%;">
    <mat-label>Recherche par nom / prénom</mat-label>
    <input matInput type="text" [value]="searchSignal()" (input)="searchSignal.set($event.target.value)">
  </mat-form-field>

  @if(filteredEleves().length > 0){
  <!-- Liste des élèves -->
  <mat-accordion>
    @for (eleve of filteredEleves(); track $index) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> @if(eleve.idAdulte !== 0){
          @if(eleve.sexe === "F"){
          <app-icon icon="woman" type="do" style="margin-right: 10px;" class="primary"></app-icon>
          }@else {
          <app-icon icon="man" type="do" style="margin-right: 10px;" class="primary"></app-icon>
          }
          }@else{
          @if(eleve.sexe === "F"){
          <app-icon icon="fille" type="do" style="margin-right: 10px;" class="primary"></app-icon>
          }@else {
          <app-icon icon="garcon" type="do" style="margin-right: 10px;" class="primary"></app-icon>
          }
          }
          {{eleve.nomReferent}} </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="fx-direction-row fx-wrap fx-gap-10">
        @if(eleve.idAdulte !== 0){
        <ng-container
          *ngTemplateOutlet="contactCardTemplate; context: { adulte: eleve.adulte1, idEnfant:eleve.idEnfant}"></ng-container>
        }
        @if(eleve.idEnfant !== 0){
        @if(eleve.adulte1.nom && eleve.adulte1.prenom){
        <ng-container
          *ngTemplateOutlet="contactCardTemplate; context: { adulte: eleve.adulte1, idEnfant:eleve.idEnfant }"></ng-container>
        }
        @if(eleve.adulte2.nom && eleve.adulte2.prenom){
        <ng-container
          *ngTemplateOutlet="contactCardTemplate; context: { adulte: eleve.adulte2, idEnfant:eleve.idEnfant }"></ng-container>
        }
        }
      </div>
    </mat-expansion-panel>
    }
  </mat-accordion>
  }@else {
  <p class="section-admin-subtitle">Aucun élève.</p>
  }
</div>
}

<ng-template #contactCardTemplate let-adulte="adulte" let-idEnfant="idEnfant">
  <mat-card appearance="outlined" class="fx-flex-auto" style="padding: 6px;">
    <!-- Nom Prenom Responsable -->
    @if(idEnfant !== 0){
    <div style="font-size: smaller;">
      @if(adulte.sexe === "F"){
      <app-icon icon="woman" type="do" style="margin-right: 3px;"></app-icon>
      }@else {
      <app-icon icon="man" type="do" style="margin-right: 3px;"></app-icon>
      }
      <span>{{adulte.nom}} {{adulte.prenom}}</span>
    </div>
    }

    <!-- Adresse -->
    <span class="fx-direction-row fx-start-start fx-gap-3" style="margin-top: 5px;">
      <mat-icon>location_on</mat-icon>
      <div style="font-size: smaller;">
        @if(adulte.rue){
        <span>
          @if (adulte.numRue) {
          {{adulte.numRue}}
          }
          {{adulte.rue}}
          <br>
        </span>
        }
        @if(adulte.rue2){
        <span>
          {{adulte.rue2}}
          <br>
        </span>
        }
        @if(adulte.rue3){
        <span>
          {{adulte.rue3}}
          <br>
        </span>
        }
        @if(adulte.ville){
        <span>
          @if(adulte.codePostal){
          {{adulte.codePostal}}
          }
          {{adulte.ville}}
          <br>
        </span>
        }
      </div>
    </span>

    <!-- Téléphones -->
    <span class="fx-direction-row fx-start-start fx-gap-3" style="margin-top: 5px;">
      <mat-icon>phone_enabled</mat-icon>
      <div style="font-size: smaller;">
        @if(adulte.telMobile){
        <span>
          <a [href]="'tel:' + adulte.telMobile">{{ adulte.telMobile }}</a>
          <br>
        </span>
        }
        @if(adulte.telephone){
        <span>
          <a [href]="'tel:' + adulte.telephone">{{ adulte.telephone }}</a>
          <br>
        </span>
        }
      </div>
    </span>

    <!-- Email -->
    @if(adulte.email){
    <div class="fx-direction-row fx-start-center fx-gap-3" style="margin-top: 5px;">
      <mat-icon>mail</mat-icon>
      <span style="font-size: smaller;">
        <a [href]="'mailto:' + adulte.email">{{ adulte.email }}</a>
        <br>
      </span>
    </div>

    }
  </mat-card>
</ng-template>